import { z } from "zod";

import { StayAiSubscription } from "../../../schemas/stay-ai";

export type StayAiWebhookRequestBodyType = {
  subscriptionContract: StayAiSubscription;
  customer: any;
  shopifyPayload: any;
};

export const StayAiWebhookResponseBodySchema = z.literal("OK");
export type StayAiWebhookResponseBodyType = z.infer<
  typeof StayAiWebhookResponseBodySchema
>;
